import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPayment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M1.875 6.875h16.25M1.875 7.5h16.25m-13.75 4.375h5m-5 1.875h2.5m-3.125 2.5h12.5a1.875 1.875 0 0 0 1.875-1.875v-8.75A1.875 1.875 0 0 0 16.25 3.75H3.75a1.875 1.875 0 0 0-1.875 1.875v8.75A1.875 1.875 0 0 0 3.75 16.25Z"
    />
  </svg>
);
export default SvgPayment;
